import { Metamodel } from '../base/model';
import { shellStringResources as stringResources } from '../../Resources/ShellStringResources';
import { format } from '../../shared/utils/string.util';
import { AzureSqlDatabaseLinkedService } from './azure-sql.linkedservice';
import { IModel } from '../base/annotation';
import { ModelConstants } from '../model-constants';

@Metamodel.model({
    name: ModelConstants.azureSqlMiDatabase,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.AzureSQLManagedInstance_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.AzureSQLManagedInstance_DisplayText)
    ]
})
export class AzureSqlMILinkedService extends AzureSqlDatabaseLinkedService {
    public static readonly MODEL: IModel;
}
